import { useEffect, useMemo, useState } from 'react'
import { numberFormat } from '../../../helper'
import { webSocketWorkerEvent } from '../../../services'

const useAgGridActivityBlotter = ({ priceRatesNormalize }) => {
  const [activityBlotterResponse, setActivityBlotterResponse] = useState({
    activity_blotter_clients: [],
    activity_blotter_market_makers: []
  })

  useEffect(() => {
    const handelMessage = message => {
      if (message.data.type === 'get_activity_blotter') {
        setActivityBlotterResponse(message.data.data)
      }
    }
    webSocketWorkerEvent.addEventListener('message', handelMessage)
    return () => webSocketWorkerEvent.removeEventListener('message', handelMessage)
  }, [priceRatesNormalize])

  const defaultColDef = useMemo(
    () => ({
      fontSize: '14px',
      resizable: true,
      wrapText: false,
      flex: 1,
      autoHeight: false
    }),
    []
  )

  const columnsDefs = [
    {
      headerName: 'Account',
      field: 'account'
    },
    {
      headerName: 'Trades',
      field: 'trades'
    },
    {
      headerName: 'Volume (mm)',
      field: 'quantity',
      valueFormatter: params => {
        return `${numberFormat(params.data.quantity / 10 ** 6, 5)}`
      }
    },
    {
      headerName: 'P&L (USD)',
      field: 'pnl',
      valueFormatter: params => {
        return `${numberFormat(params.data.pnl)}`
      }
    }
  ]

  return { columnsDefs, defaultColDef, activityBlotterResponse }
}

export default useAgGridActivityBlotter
